var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-select", {
    attrs: {
      items: _vm.items,
      value: _vm.value,
      fancy: _vm.fancy,
      light: _vm.light,
      label: _vm.computedLabel,
    },
    on: {
      input: function ($event) {
        return _vm.onInput($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }